import React, {Component} from "react";

let UserJourney = class UserJourney extends Component{
  render(){
    return <div>User UserJourney</div>
  }
};

export default UserJourney;